
































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
@Component({
  name: "image-crop-component",
})
export default class ImageCropComponent extends Vue {
  @Prop() img: any;
  @Emit()
  change({ coordinates, canvas }) {
    return canvas.toDataURL();
  }
}
